import styles from "../css/PronunciationSelectView.module.css";
import { useTranslation } from "react-i18next";
import ChipButton from "./ChipButton";
import { useEffect, useState } from "react";
import { EnglishPronunciation } from "../../voice/util/voice";
import { setEnglishPronunciationToLocalStorage } from "../../settings/util/voiceSettings";

interface PronunciationSelectViewProps {
  open: boolean;
  selectedPronunciation: EnglishPronunciation;
  onClickAction: (
    e: React.MouseEvent<HTMLDivElement>,
    pronunciation: EnglishPronunciation
  ) => void;
}

export default function PronunciationSelectView(
  props: PronunciationSelectViewProps
) {
  const { t } = useTranslation();

  const [enButtonState, setEnButtonState] = useState(false);
  const [ukButtonState, setUkButtonState] = useState(false);
  const [auButtonState, setAuButtonState] = useState(false);

  useEffect(() => {
    updateButtonState();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedPronunciation]);

  function updateButtonState() {
    setEnButtonState(false);
    setUkButtonState(false);
    setAuButtonState(false);
    switch (props.selectedPronunciation) {
      case EnglishPronunciation.america:
        setEnButtonState(true);
        break;
      case EnglishPronunciation.england:
        setUkButtonState(true);
        break;
      case EnglishPronunciation.australia:
        setAuButtonState(true);
        break;
    }
  }

  function onClickPronunciationButton(
    pronunciation: EnglishPronunciation,
    e: React.MouseEvent<HTMLDivElement>
  ) {
    setEnglishPronunciationToLocalStorage(pronunciation);
    updateButtonState();
    props.onClickAction(e, pronunciation);
  }

  if (!props.open) return null;
  return (
    <>
      <div className={styles.container}>
        <ChipButton
          open={true}
          text={t("PronunciationEN")}
          variant={enButtonState === true ? "secondary" : "secondaryDisable"}
          onClickAction={(e: React.MouseEvent<HTMLDivElement>) => {
            onClickPronunciationButton(EnglishPronunciation.america, e);
          }}
        />
        <ChipButton
          open={true}
          text={t("PronunciationUK")}
          variant={ukButtonState === true ? "secondary" : "secondaryDisable"}
          onClickAction={(e: React.MouseEvent<HTMLDivElement>) => {
            onClickPronunciationButton(EnglishPronunciation.england, e);
          }}
        />
        <ChipButton
          open={true}
          text={t("PronunciationAU")}
          variant={auButtonState === true ? "secondary" : "secondaryDisable"}
          onClickAction={(e: React.MouseEvent<HTMLDivElement>) => {
            onClickPronunciationButton(EnglishPronunciation.australia, e);
          }}
        />
      </div>
    </>
  );
}
